import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { CourseFeedback } from '@interfaces';
import { ExperienceAreaService } from '../../../experience-area.service';
import { ExperienceCoursesService } from '../../experience-courses.service';
import { getSetup } from './grid/get-setup';

export interface AcceleratorCourseFeedback extends CourseFeedback {
	accId: number,
	accName: string,
	courseVersionId: number,
	courseTitle: string,
}

@Component({
	selector: 'experience-courses-accelerator-course-feedback-view-part',
	standalone: true,
	imports: [
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './accelerator-course-feedback-view.part.html',
})
export class ExperienceCoursesAcceleratorCourseFeedbackViewPart {

	private readonly service = inject(ExperienceCoursesService);
	private readonly areaService = inject(ExperienceAreaService);
	private util = inject(UtilityService);
	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.service.layout()) return { layout: this.service.layout()!, viewSelector: true };
		return undefined;
	});

	public readonly feedback = computed(() => {
		const data = this.areaService.experienceData();
		if (!data) return [];

		const courseEnrollmentById = this.util.array.toMap(data.acceleratorEnrollments, e => e.courseEnrollmentId);

		return data.acceleratorCourseFeedback.map(fb => {
			const enrollment = courseEnrollmentById[fb.courseEnrollmentId]!; // enrollment is guaranteed to be defined as feedbacks are filtered by enrollments
			return {
				...fb,
				accId: enrollment.accId,
				accName: enrollment.acceleratorName,
				courseVersionId: enrollment.courseVersionId,
				courseTitle: enrollment.courseTitle,
				updatedUTC: enrollment.updatedUTC,
			};
		})
	});

}
